import { LinkButton } from 'ui/inputs/Button/LinkButton'
import { buildStaticDashItem, CardLink, CardOptions } from '../components'

const DebtConsolidationCalculator: CardOptions = {
	title: 'Debt Consolidation Calculator',
	imageUrl: '/images/illustrations/debt-consolidation-calc.svg',
	body: 'Find out if consolidating your debt could save you money.',
	footer: <CardLink href={'/tools/debt-consolidation-calculator'} cta={'Try the Calculator'} />
}

const WelcomeContent: CardOptions = {
	title: 'Welcome to your dashboard',
	imageUrl: '/images/illustrations/dashboard-welcome-card.svg',
	body: 'As you explore Fiona, new cards will appear on your dashboard.'
}

const NewSearch: CardOptions = {
	title: 'Start a Search',
	imageUrl: '/images/illustrations/dashboard-empty-search-list.svg',
	body: 'Create a search to get matched with financial products like loans or credit cards',
	// Link Button
	footer: <LinkButton href="/search/new">New Search</LinkButton>
}

export const StaticContent = {
	NewSearch: buildStaticDashItem(NewSearch),
	WelcomeContent: buildStaticDashItem(WelcomeContent),
	DebtConsolidationCalculator: buildStaticDashItem(DebtConsolidationCalculator)
}
